export default API => ({
    getCmsContent(data) {
        return API({
            url: `/cms/v1/special/getSpecialContent`,
            method: 'post',
            params: data
        })
    },
    /**
     * 文章详情
     *
     */
    getArticleDetail(data) {
        return API({
            url: `/modular/admin/v1/block/getArticleInfo`,
            method: 'post',
            data: {
                ...data,
                articleId: data.articleId ? data.articleId : data.id,
                branchId: localStorage.getItem('branchId'),
            }
        });
    },

    /**
     * 根据id 返回 视频 图片 详情
     *
     */
    getImageList(data) {
        return API({
            url: `/cms/v1/article/getFiles`,
            method: 'post',
            data: data
        });
    }
});
